import React from 'react';
import './PolicyPages.css';

const CancellationRefund = () => {
  return (
    <div className="policy-page-container">
      <div className="policy-content">
        <h1 className="policy-title">Cancellation & Refund Policy – House of Microgreens</h1>
        <p className="policy-updated">Last updated: 25 November 2025</p>
        
        <p className="policy-intro">
          Fresh microgreens are highly perishable, so our cancellation and refund rules are strict but fair.
        </p>

        <section className="policy-section">
          <h2>1. Cancellation Policy</h2>
          
          <h3>One-time / Sample Orders</h3>
          <ul>
            <li>Can be cancelled before harvest/packing begins.</li>
            <li>Once preparation starts, cancellation is not allowed.</li>
          </ul>

          <h3>Subscription Orders</h3>
          <ul>
            <li>You may cancel or pause the upcoming cycle before the communicated cut-off time.</li>
            <li>Deliveries already scheduled or harvested cannot be cancelled.</li>
          </ul>

          <p>To request cancellation, contact us by WhatsApp, phone, or email.</p>
        </section>

        <section className="policy-section">
          <h2>2. Refund Policy</h2>
          <p>Refunds are eligible only in the following situations:</p>
          
          <h3>You will receive a refund if:</h3>
          <ul>
            <li>We cannot deliver to your location after payment.</li>
            <li>We cancel your order due to unexpected operational issues.</li>
            <li>You report a valid quality issue within a few hours of delivery and provide proof (photo/video).</li>
          </ul>

          <h3>Refund Duration:</h3>
          <p>
            Approved refunds will be processed to the original payment method within 7–10 working days 
            (depends on bank/Razorpay).
          </p>

          <h3>Refunds NOT provided for:</h3>
          <ul>
            <li>Change of mind after placing the order</li>
            <li>Incorrect address, unreachable customer</li>
            <li>Cancellations after harvesting/packing</li>
            <li>Delays caused by unavoidable factors (rain, traffic, strikes, etc.)</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Replacement Policy</h2>
          <p>Instead of refunds, we may offer:</p>
          <ul>
            <li>Free replacement in next delivery, or</li>
            <li>Partial credit/discount, or</li>
            <li>Full replacement in genuine cases</li>
          </ul>

          <h3>Eligibility:</h3>
          <ul>
            <li>Issue must be reported within a few hours of delivery.</li>
            <li>Clear photos/videos must be shared.</li>
            <li>The final decision rests with House of Microgreens after evaluating the situation.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Contact for Cancellations & Refunds</h2>
          <p><strong>Email:</strong> hi@houseofmicrogreens.in</p>
          <p><strong>Phone/WhatsApp:</strong> +916363312348</p>
        </section>
      </div>
    </div>
  );
};

export default CancellationRefund;
